import {
  ADD_IMAGE_TO_TEXTURE,
  GET_IMAGES,
  CREATE_TEXTURE,
  REMOVE_TEXTURE,
  SET_ZOOM_SCALE,
  ROTATE_IMAGE,
  RESET_TRANSFORMATIONS,
  REMOVE_TEXTURE_IMAGE,
  MOVE_IMAGE,
  FIT_IMAGE,
  CHANGE_TEXTURE_ORDER,
  FILL_IMAGE_SIZE,
  ADD_IMAGE_OBJECT,
  DPI_RESOLUTION,
  REMOVE_DPI_OVERLAY,
  ADD_DROPPED_IMAGE_TO_TEXTURE,
  REMOVE_IMAGE_FROM_TEXTURE,
  REORDER_PLACEHOLDERS,
  TOGGLE_DPI_OVERLAYS,
  LOAD_PLACEHOLDERS_BY_BOOK_ID,
  CHANGE_FILL_IMAGE_SIZE,
} from '../../action-types/entities/placeholders';
/**
 * texture model
 * {
 *    image: id,
 * }
 */

export const addImageToTexture = (imageId, placeholdersId) => ({
  type: ADD_IMAGE_TO_TEXTURE,
  imageId,
  placeholdersId,
});
export const getImages = placeholders => ({
  type: GET_IMAGES,
  placeholders,
});
export const createTexture = texture => ({
  type: CREATE_TEXTURE,
  texture,
});
export const removeTexture = placeholdersId => ({
  type: REMOVE_TEXTURE,
  placeholdersId,
});
export const addImageObject = (placeholderId, imageObject) => ({
  type: ADD_IMAGE_OBJECT,
  placeholderId,
  imageObject,
});

export const setZoom = (placeholderId, zoomIn) => (dispatch, getState) => {
  dispatch(setZoomScale(placeholderId, zoomIn));
};

export const setRotateImage = (placeholderId, left, rotate) => (dispatch, getState) => {
  dispatch(rotateImage(placeholderId, left, rotate));
};

export const resetAllTransformations = (placeholderId, center) => (dispatch, getState) => {
  dispatch(resetTransformations(placeholderId, center));
};
/**
 * addTransformation
 *  togglePageProcessing (pageId, 1)
 *
 *
 * togglePageProcessing(pageId, isProcessing)
 *  isProcessing = 0
 *    generatePreviewImage(pageId)
 */

export const setZoomScale = (placeholderId, zoomIn) => ({
  type: SET_ZOOM_SCALE,
  placeholderId,
  zoomIn,
});
export const rotateImage = (placeholderId, left, rotate) => ({
  type: ROTATE_IMAGE,
  placeholderId,
  left,
  rotate,
});
export const resetTransformations = (placeholderId, center) => ({
  type: RESET_TRANSFORMATIONS,
  placeholderId,
  center,
});
export const removeTextureImage = placeholderId => ({
  type: REMOVE_TEXTURE_IMAGE,
  placeholderId,
});
export const moveImage = (placeholderId, moveX, moveY) => ({
  type: MOVE_IMAGE,
  placeholderId,
  moveX,
  moveY,
});
export const fitImage = (placeholderId, isFit, fitSizes) => ({
  type: FIT_IMAGE,
  placeholderId,
  isFit,
  fitSizes,
});
export const changeTextureOrder = (
  oldplaceholderId, oldTextureImage, newplaceholderId, newTextureImage,
  toFillSizes, fromFillSizes, toImageRatio, fromImageRatio, fromCenter, toCenter,
) => (
  {
    type: CHANGE_TEXTURE_ORDER,
    oldplaceholderId,
    oldTextureImage,
    newplaceholderId,
    newTextureImage,
    toFillSizes,
    fromFillSizes,
    toImageRatio,
    fromImageRatio,
    fromCenter,
    toCenter,
  }
);

export const fillImageSize = (sizes, placeholderId) => ({
  type: FILL_IMAGE_SIZE,
  sizes,
  placeholderId,
});

export const changeFillImageSize = (sizes, placeholderId) => ({
  type: CHANGE_FILL_IMAGE_SIZE,
  sizes,
  placeholderId,
});

export const dpiResolution = (placeholderId, isSmall) => ({
  type: DPI_RESOLUTION,
  placeholderId,
  isSmall,
});

export const removeDPIOverlay = (placeholderId, isClicked) => ({
  type: REMOVE_DPI_OVERLAY,
  placeholderId,
  isClicked,
});

export const addDroppedImageToTexture = (placeholderId, imgObject, imageId, fillSize) => ({
  type: ADD_DROPPED_IMAGE_TO_TEXTURE,
  placeholderId,
  imgObject,
  imageId,
  fillSize,
});

export const removeImageFromTexture = placeholderId => ({
  type: REMOVE_IMAGE_FROM_TEXTURE,
  placeholderId,
});

export const reorderPlaceholders = currentPage => ({
  type: REORDER_PLACEHOLDERS,
  currentPage,
});

export const toggleDpiOverlays = status => ({
  type: TOGGLE_DPI_OVERLAYS,
  status,
});

export const loadPlaceholdersByBookId = bookState => ({
  type: LOAD_PLACEHOLDERS_BY_BOOK_ID,
  bookState,
});



// WEBPACK FOOTER //
// ./src/redux/actions/entities/placeholders.js